import {
    WALLET_TOKEN_COUNT_ERROR,
    WALLET_TOKEN_COUNT_LOAD,
    WALLET_TOKEN_COUNT_SUCCESS,
    WALLET_TOKEN_ERROR,
    WALLET_TOKEN_SUBMIT,
    WALLET_TOKEN_SUCCESS,
    WALLET_GET_TOKEN_LOAD,
    WALLET_GET_TOKEN_ERROR,
    WALLET_GET_TOKEN_SUCCESS,
    WALLET_TOKEN_REWARDS_ERROR,
    WALLET_TOKEN_REWARDS_LOAD,
    WALLET_TOKEN_REWARDS_SUCCESS,
    WALLET_TOKEN_REQUEST_ERROR,
    WALLET_TOKEN_REQUEST_LOAD,
    WALLET_TOKEN_REQUEST_SUCCESS,
    WALLET_TOKEN_YIELDFEE_ERROR,
    WALLET_TOKEN_YIELDFEE_LOAD,
    WALLET_TOKEN_YIELDFEE_SUCCESS
} from '../actionTypes'

import { request } from '../../utils/api'
import moment from 'moment'
import { setInfoLocalStorage } from '../../utils/api'
const formatarMoeda = (valor) => { 
    valor = Number(valor).toFixed(2) + '';
    valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor).replace('R$', '')  
    return valor;
}

export const countTokens = () => async dispatch => {
    try {
        dispatch(countLoad())
        const { code, tokens } = await request("wallet/count-tokens")
        if(code === 200) {
            dispatch(countSuccess(tokens))
        } else {
            dispatch(countError())
        }
    } catch (e) {
        dispatch(countError())
    }
}

export const countLoad = () => ({
    type: WALLET_TOKEN_COUNT_LOAD
})

export const countError = () => ({
    type: WALLET_TOKEN_COUNT_ERROR
})

export const countSuccess = (tokens) => ({
    type: WALLET_TOKEN_COUNT_SUCCESS,
    payload: {
        tokens
    }
})

export const buyToken = (enderecoSolana, qt, idCliente) => async dispatch => {
    try {
        dispatch(onTokenSubmit())
        const { code, message } = await request("wallet/buy-token", "POST", {
            enderecoSolana,
            qt,
            idCliente
        })
        if(code === 200) {
            dispatch(onTokenSuccess())
        } else {
            dispatch(onTokenError(message))
        }
    } catch (e) {
        dispatch(onTokenError(e))
    }
}

export const onTokenSubmit = () => ({
    type: WALLET_TOKEN_SUBMIT
})

export const onTokenError = (message) => ({
    type: WALLET_TOKEN_ERROR,
    payload: {
        message
    }
})

export const onTokenSuccess = () => ({
    type: WALLET_TOKEN_SUCCESS
})

export const getTokens = (idWallet, address) => async dispatch => {
    try {
        dispatch(tokenLoad())
        const { code, tvlHistory, taxa, dtWallet, tokensMonth, tokensApprovals } = await request(`wallet/tokens/${idWallet}/${address}`)
        if(code === 200) {
            var data = []
            var labels = []
            var yieldChart = parseFloat(tvlHistory[0]['yield'])
            for(var j = 0; j < tvlHistory.length; j++) {
                yieldChart = yieldChart + parseFloat(tvlHistory[j]['yield'])
                data.push(yieldChart)
                labels.push(moment(tvlHistory[j]['createdAt']).format("MMMM"))
            }
            let options = {
                responsive: true,
                legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    fontColor: '#130E24',
                    fontSize: 14,
                    fontFamily: 'Arial',
                    boxWidth: 10
                }
                },
                scales: {
                xAxes: [{
                    ticks: {
                        fontColor: "rgba(235, 161, 238, 1)",
                    },
                    gridLines: {
                        display: false,
                        color: "#F7D9F8"
                    },
                }],
                yAxes: [{
                    ticks: {
                        fontColor: "rgba(235, 161, 238, 1)",
                        callback: function(value, index, values){ return 'R$'+formatarMoeda(value)},
                    },
                    gridLines: {
                        // display: false,
                        color: "#F7D9F8"
                    },
                }]
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        label: function(tooltipItems, data) { 
                            return data.datasets[tooltipItems.datasetIndex].label + ': ' + 'R$'+formatarMoeda(tooltipItems.yLabel);
                        }
                    }
                },
            }
            var chart = {
                labels,
                options,
                datasets: [
                    {
                        label: 'Histórico de Yield',
                        data,
                        pointBorderColor: 'rgba(64, 51, 115, 1)',
                        pointBackgroundColor: '#fff', backgroundColor: 'transparent', fill: false,borderColor: 'rgba(64, 51, 115, 1)', 
                        pointRadius: 2
                    }
                ]
            }
            var totalW = 0
            var dataW = []
            var labelsW = []
            for(var k = 0; k < dtWallet.length; k++) {
                totalW = totalW + parseInt(dtWallet[k].valor)
                dataW.push(dtWallet[k]['valor']/100)
                labelsW.push(moment(dtWallet[k]['createdAt']).format("MMMM"))
            }
            let optionsW = {
                height: '200px',
                responsive: true,
                legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    fontColor: '#130E24',
                    fontSize: 14,
                    fontFamily: 'Arial',
                    boxWidth: 10
                }
                },
                scales: {
                xAxes: [{
                    ticks: {
                        fontColor: "rgba(235, 161, 238, 1)",
                    },
                    gridLines: {
                        display: false,
                        color: "#F7D9F8"
                    },
                    barThickness: 20,
                }],
                yAxes: [{
                    ticks: {
                        fontColor: "rgba(235, 161, 238, 1)",
                        callback: function(value, index, values){ return 'R$' + formatarMoeda(value)},
                    },
                    gridLines: {
                        // display: false,
                        color: "#F7D9F8"
                    },
                }]
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        label: function(tooltipItems, data) { 
                            return data.datasets[tooltipItems.datasetIndex].label + ': ' + 'R$' + formatarMoeda(tooltipItems.yLabel);
                        }
                    }
                },
            }
            var chartFLWT = {
                labels: labelsW,
                options: optionsW,
                datasets: [
                    {
                        label: 'Dividendos de participação',
                        data: dataW,
                        backgroundColor: 'rgba(64, 51, 115, 1)',
                    }
                ]
            }
            dispatch(tokenSuccess(tvlHistory, taxa, chart, dtWallet, chartFLWT, totalW, tokensMonth, tokensApprovals))
        } else {
            if(code === 403) {
                window.location.replace(`/wallet/flwt?error=403`)
            }
            dispatch(tokenError())
        }
    } catch (e) {
        dispatch(tokenError())
    }
}

export const tokenLoad = () => ({
    type: WALLET_GET_TOKEN_LOAD
})

export const tokenError = () => ({
    type: WALLET_GET_TOKEN_ERROR
})

export const tokenSuccess = (tvlHistory, taxa, chart, dtWallet, chartW, totalRewards, tokensMonth, tokensApprovals) => ({
    type: WALLET_GET_TOKEN_SUCCESS,
    payload: {
        tvlHistory,
        taxa,
        chart,
        dtWallet,
        chartW,
        totalRewards,
        tokensMonth,
        tokensApprovals
    }
})

export const getRequestedTokens = () => async dispatch => {
    try {
        dispatch(requestedTokensLoad())
        const { code, vendas } = await request("wallet/requested-tokens")
        if(code === 200) {
            dispatch(requestedTokenSuccess(vendas))
        } else {
            dispatch(requestedTokenError())
        }
    } catch (e) {
        dispatch(requestedTokenError())
    }
}

export const requestedTokensLoad = () => ({
    type: WALLET_TOKEN_REQUEST_LOAD
})

export const requestedTokenError = () => ({
    type: WALLET_TOKEN_REQUEST_ERROR
})

export const requestedTokenSuccess = (vendas) => ({
    type: WALLET_TOKEN_REQUEST_SUCCESS,
    payload: {
        vendas
    }
})

export const getYieldFee = () => async dispatch => {
    try {
        dispatch(yieldFeeLoad())
        const { code, fee } = await request("wallet/yield-fee")
        if(code === 200) {
            dispatch(yieldFeeSuccess(fee))
        } else {
            dispatch(yieldFeeError())
        }
    } catch (e) {
        dispatch(yieldFeeError())
    }
}

export const yieldFeeLoad = () => ({
    type: WALLET_TOKEN_YIELDFEE_LOAD
})

export const yieldFeeError = () => ({
    type: WALLET_TOKEN_YIELDFEE_ERROR
})

export const yieldFeeSuccess = (fee) => ({
    type: WALLET_TOKEN_YIELDFEE_SUCCESS,
    payload: {
        fee
    }
})